import {useState, useEffect, useMemo} from 'react';
import Select from 'react-select';
import { Typography, useTheme } from '@mui/material';
import PlantillaEmailService from '../../services/plantillaEmails.service';


const SelectPlantillaEmail = ({value,disabled,onChange,isClearable,errorText, ...props}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [selectedValue, setSelectedValue] = useState();
    const [options, setOptions] = useState([]);
    const [items, setItems] = useState([]);
    const actualizar = async() =>{
        await PlantillaEmailService.getAll().then((resp)=>{
            if(resp?.length > 0){
                setItems(resp)
            }
        })
    }
    const onSelectValue =
    useMemo(() =>
        (ev) => {
            setSelectedValue(ev)
            if(Array.isArray(ev)){
                onChange(ev.map(e=>{
                    const item = items.find(it=>it.id_pmail === e.value);
                    return {
                        ...e,
                        item: item,
                    }
                }));
            } else if(ev){
                ev.item = items.find(it=>it.id_pmail === ev.value);
                onChange(ev);
            } else {
                onChange(null);
            }
        }
    , [])

    useEffect(() => {
        if(items?.length > 0){
            const newOptions = items.map((item) => {
                return {
                    value: item.id_pmail,
                    label: `${item?.asunto_pmail} - ${item?.correo_pmail}`,
                    ...item
                };
            });
            setOptions(newOptions);
        }
    }, [items,]);

    useEffect(() => {
        if( options.length > 0 ){
            if (typeof value === 'string' || typeof value === 'number') {
                setSelectedValue(options.find((opt) => opt.value === value));
            } else if(Array.isArray(value)){
                setSelectedValue(value.map((va)=>{
                const busq = options?.find((it)=> it.value === va)
                    return({
                        label:busq?.label,
                        value:busq?.value,
                        ...busq
                    })
                }))
            }
        }
    }, [options,value])

    useEffect(() => {
        actualizar();
    }, [])

    const customStyles = useMemo(() => ({
        menuPortal: (base) => ({...base, zIndex: 9999}),
        menu: (base) => ({
            ...base,
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
            border: isDarkMode ? '1px solid #3d4a62' : '1px solid #e0e0e0'
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? (isDarkMode ? '#90caf9' : '#fff') : (isDarkMode ? '#e0e0e0' : '#000'),
            background: state.isSelected ? (isDarkMode ? '#1a3a5c' : '#0364ff') : (isDarkMode ? '#2d3a52' : '#fff'),
            '&:hover': {
                backgroundColor: isDarkMode ? '#3d4a62' : '#02378c',
                color: '#fff',
            },
        }),
        control: (styles)=>({
            ...styles,
            borderRadius: 7,
            borderColor: isDarkMode ? '#3d4a62' : 'gray',
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
            '&:hover': {
                borderColor: isDarkMode ? '#64B5F6' : '#0364ff'
            }
        }),
        singleValue: (provided) => ({
            ...provided,
            color: isDarkMode ? '#e0e0e0' : '#000'
        }),
        input: (provided) => ({
            ...provided,
            color: isDarkMode ? '#e0e0e0' : '#000'
        }),
        placeholder: (provided) => ({
            ...provided,
            color: isDarkMode ? '#b0bec5' : 'gray'
        }),
        multiValue: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: isDarkMode ? '#1a3a5c' : '#0364ff',
                borderRadius: 5
            };
        },
        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5,
            '&:hover': {
                backgroundColor: '#02378c',
                color: '#fff',
            },
        })
    }), [isDarkMode])

    return (
        <Select
            {...props}
            className='react-select-container'
            styles={customStyles}
            menuPortalTarget={document.body}
            classNamePrefix="react-select"
            placeholder='Seleccione...'
            options={options}
            value={selectedValue}
            onChange={onSelectValue}
            isClearable={isClearable}
            isDisabled={disabled}
            menuShouldScrollIntoView
            menuPosition='absolute'
            menuPlacement='auto'
        />
    );
};

SelectPlantillaEmail.defaultProps = {
    isClearable: false,
    value: null
};

export default SelectPlantillaEmail;